import { get } from "common/request"

export const taskRequest = {
  count: () => get("/api/tasks/countByType"),
  assessments: () => get("/api/tasks/assessments"),
  templates: () => get("/api/tasks/templates"),
  reports: params => get(`/api/massReports/tasks?${params}`),
}
